module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('PrivateLink', {
    staticClass: "item",
    attrs: {
      "to": _vm.to,
      "target": _vm.target
    }
  }, [(_vm.showBadge) ? _c('div', {
    staticClass: "badge"
  }, [_c('MoreBadge', {
    staticClass: "img__module",
    attrs: {
      "interval": 3000,
      "items": _vm.badge
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "img",
    style: (_vm.imgStyle)
  }, [(_vm.price) ? _c('MorePrice', {
    staticClass: "price",
    attrs: {
      "value": _vm.price
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hours"
  }, [(_vm.labor_program) ? _c('div', {
    staticClass: "labor"
  }, [_vm._v(_vm._s(_vm.labor_program))]) : _vm._e(), (_vm.length) ? _c('div', {
    staticClass: "length"
  }, [_vm._v(_vm._s(_vm.length))]) : _vm._e()])], 1), _c('div', {
    staticClass: "info"
  }, [_c('MoreTitle', [_vm._v(_vm._s(_vm.title))]), (_vm.note) ? _c('MoreNote', [_vm._v(_vm._s(_vm.note))]) : _vm._e(), (!_vm.note && _vm.isTextString) ? _c('MoreNote', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), (!_vm.note && _vm.isTextArray) ? _c('MoreNote', _vm._l((_vm.text), function(line, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(line))])
  }), 0) : _vm._e()], 1), (_vm.formEducation) ? _c('div', {
    staticClass: "form"
  }, [_vm._v(_vm._s(_vm.formEducation))]) : _vm._e(), (_vm.isLockedText) ? _c('Locked', {
    staticClass: "form-locked",
    attrs: {
      "isCost": true
    }
  }) : _vm._e(), _c('div', {
    staticClass: "footer"
  }, [_c('MoreButton'), (_vm.programCost) ? _c('div', {
    staticClass: "cost"
  }, [_vm._v(_vm._s(_vm.programCost))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-521896f1","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/list/item/double/component.vue
// module id = d70b60c6d346c7ffeb38
// module chunks = 89